// extracted by mini-css-extract-plugin
export default {"bigContainer":"NotFound_bigContainer__xGIEp","header":"NotFound_header__q+gZW","main":"NotFound_main__JmUMk"};